<div fxFlex="row" fxLayoutAlign="start center" class="header">
    <div fxFlex="row" fxLayoutAlign="start center">
        <div
            class="container-img"
            [ngClass]="{
                'container-img': !getMatSidenav,
                'container-img-open': getMatSidenav
            }"
        >
            <div
                [ngClass]="{
                    'show-logo': !getMatSidenav,
                    'not-show-logo': getMatSidenav
                }"
            >
                <img
                    src="../../../assets/img/mb-icon/mb.png"
                    *ngIf="!getMatSidenav"
                />
            </div>
            <div
                [ngClass]="{
                    'show-logo': getMatSidenav,
                    'not-show-logo': !getMatSidenav
                }"
            >
                <img
                    src="../../../assets/img/mb-icon/monte.svg"
                    *ngIf="getMatSidenav"
                    style="width: 150px"
                />
            </div>
        </div>
    </div>

    <button mat-button [matMenuTriggerFor]="menu" class="btn-right-menu">
        <div
            class="container-profile"
            fxFlex="row"
            fxLayoutAlign="center center"
        >
            <div class="backgound">
                <div>
                    {{ initialName }}
                </div>
            </div>
            <span>{{ name }}</span>
            <div fxFlex="row" fxLayoutAlign="center center">
                <app-mb-icon
                    icon="select-down"
                    class="material-icons-outlined"
                ></app-mb-icon>
            </div>
        </div>
    </button>
</div>
<mat-menu #menu="matMenu">
    <button mat-menu-item (click)="logout()">
        <app-mb-icon icon="logout"></app-mb-icon>
        <span>Sair</span>
    </button>
</mat-menu>
